import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../util/SkeletonColor";
import Iconb from "../../extra/Iconb";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import Table from "../../extra/Table";
import ToggleSwitch from "../../extra/ToggleSwitch";
import { clearUserProfile, getUser, userIsBlock } from "../../store/user/user.action";

// import Info from "../../../assets/images/Info.svg"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconCopy } from "@tabler/icons-react";
import { usePermission } from "../../../hooks/usePermission";



const User = (props) => {

  const { can } = usePermission();
  const canEdit = can("User", "Edit");



  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { user, totalUser, loadingg } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const navigate = useNavigate();



  useEffect(() => {
    // setLoading(true);
    dispatch(getUser(currentPage, size))
  }, [dispatch, currentPage, size]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 1500); // Adjust the delay time as needed

  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    setData(user);
  }, [user]);

  // pagination
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event), 10);
    setSize(parseInt(event), 10);
    setCurrentPage(1);
  };

  const handleOpen = (id) => {
    dispatch(clearUserProfile());
    navigate("/admin/UserProfile", {
      state: id,
    });
  };

  const handleClick = (userDetails) => {

    props.userIsBlock(
      userDetails,
      userDetails?.isBlock === true ? false : true
    );
  };

  // searching
  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const copyToClipboard = (Text) => {
    navigator.clipboard.writeText(Text);
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => (
        <span className="text-white">
          {(currentPage - 1) * rowsPerPage + index + 1}
        </span>
      ),
    },
    {
      Header: "User",
      body: "firstName",
      Cell: ({ row }) => (
        <div
          className="d-flex"
          onClick={() => handleOpen(row._id)}
          style={{ cursor: "pointer" }}
        >
          <div className="position-relative">
            {loadingg ? (
              <>
                <Skeleton
                  height={42}
                  width={42}
                  style={{ borderRadius: "90px" }}
                  className="StripeElement "
                  baseColor={colors?.baseColor}
                  highlightColor={colors?.highlightColor}

                />
              </>
            ) : (
              <>
                <img
                  src={row?.image}
                  height={45}
                  width={45}
                  alt=""
                  style={{ borderRadius: "90px" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/dummy.png";
                  }}
                />

              </>
            )}
          </div>
          <span className="fw-normal ms-3 boxCenter text-start ">
            <b className="fw-normal text-capitalize text-white">
              {row.firstName + " " + row.lastName}
            </b>
          </span>
        </div>
      ),
      sorting: false,    //you can on if sorting need
    },

    {
      Header: "Contact",
      body: "email",
      sorting: false,
      Cell: ({ row }) => (
        <div className="">
          <span className="text-white fw-normal">{row.email ? row.email : "jallab@gmail.com"}</span>
          <p className="mb-0 text-white fw-normal">{row.mobileNumber ? row.mobileNumber : "-"}</p>
        </div>
      ),
    },

    {
      Header: "Unique Id", body: "uniqueId", sorting: false,

      Cell: ({ row }) => (
        <p className="mb-0 text-white">
          {row.uniqueId ? row.uniqueId : "-"}  <IconCopy
            size={16}
            className="ms-1"
            style={{ cursor: "pointer" }}
            onClick={() => copyToClipboard(row.uniqueId ? row.uniqueId : "-")}
          />
        </p>
      ),
    },
    {
      Header: "Country",
      body: "location",
      Cell: ({ row }) => (
        <p className="mb-0 text-uppercase text-white">
          {row.location ? row.location : "-"}
        </p>
      ),
    },
    {
      Header: "Total Order",
      body: "orderCount",
      Cell: ({ row }) => (
        <span
          className="mb-0 text-dark"
          style={{
            backgroundColor: "#c6e7ff",
            color: "#008df2",
            padding: "10px 15px",
            borderRadius: "5px",
          }}
        >
          {row.orderCount ? row.orderCount : 0}
        </span>
      ),
    },
    {
      Header: "Register Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white">{dayjs(row.date).format("DD MMM YYYY")}</span>
      ),
    },

    ...(canEdit ? [
      {
        Header: "Block",
        body: "isBlock",
        Cell: ({ row }) => (
          <div className="">

            <ToggleSwitch value={row.isBlock} onClick={() => handleClick(row)}/>
          </div>
        ),
      }
    ] : []),


    {
      Header: "Info",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          type="button"
          newClass={` boxCenter   infobtn userBtn  `}
          btnIcon={<InfoOutlinedIcon sx={{ color: '#737272' }} />}
          style={{
            borderRadius: "80px",
            margin: "auto",
            height: "38px",
            width: "38px",
            color: "#160d98",



          }}
          isImage={true}
          isDeleted={true}
          onClick={() => handleOpen(row._id)}
        />


      ),
    },

    // add more columns as needed
  ];
  return (
    <>
      <div className="mainUserTable">
        <div className="userTable">
          <div className="col-12 headname">User Management </div>

          <div className="userMain">
            <div className="tableMain mt-2">
              <div className="userHeader primeHeader">
                <div className="row">
                  <div className="col-2"></div>
                  <div className="col-10">
                    <Searching
                      type={`client`}
                      data={user}
                      setData={setData}
                      column={data}
                      onFilterData={handleFilterData}
                      serverSearching={handleFilterData}
                      button={true}
                      setSearchValue={setSearch}
                      searchValue={search}
                    />
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                serverPerPage={rowsPerPage}
                serverPage={page}
                type={"server"}
                loading={loadingg}
              />
              <Pagination
                component="div"
                count={user?.length}
                type={"server"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={totalUser}
                serverPage={currentPage}
                setCurrentPage={setCurrentPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <div className="userFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getUser, userIsBlock })(User);
